import styled from '@emotion/styled';

import { button, maxWidthAndCenter } from '@styles';

const NavigationContainer = styled.nav`
  position: sticky;
  padding: 1rem 0;
  top: 0px;
  z-index: 999;

  background: white;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.15);

  .navigation__row {
    display: flex;
    ${maxWidthAndCenter}
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .navigation__logo {
    max-width: 250px;
    flex-shrink: 0;
  }

  .navigation__links {
    padding: 0 3rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .navigation__link {
    color: var(--gray);
    text-decoration: none;
    font-weight: 600;
    transition: color ease-in 0.1s;
    user-select: none;

    &:visited {
      color: var(--gray);
    }

    &:hover {
      color: var(--dark-gray);
    }
  }

  .navigation__link_wrapper {
    position: relative;

    // Show subnavigation menus on hover.
    :hover > div:first-of-type {
      opacity: 100;
      pointer-events: all;
    }
  }

  .navigation__link_expand {
    position: absolute;
    font-size: 1.5rem;
    transform: rotate(90deg);
    top: -0.25rem;
    right: -1rem;
  }

  .navigation__cta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-shrink: 0;

    a:first-of-type {
      ${button('blue')}
      margin: 0 0.5rem 0 0;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      white-space: nowrap;
    }

    a:last-of-type {
      ${button('orange')}
      padding-left: 1.25rem;
      padding-right: 1.25rem;
    }
  }

  .navigation__mobile {
    position: absolute;
    display: none;
    visibility: hidden;
    top: 2.25rem;
    right: 1rem;
    width: 2.75rem;
    height: 2rem;
    transform: rotate(0deg);
    transition: 0.5s ease-in-out;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      height: 0.33rem;
      width: 100%;
      background: var(--blue);
      border-radius: 9px;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;
    }

    span:nth-of-type(1) {
      top: 0rem;
    }

    span:nth-of-type(2),
    span:nth-of-type(3) {
      top: 0.75rem;
    }

    span:nth-of-type(4) {
      top: 1.5rem;
    }

    &--open span {
      background: var(--orange);
    }

    &--open span:nth-of-type(1) {
      top: 1rem;
      width: 0%;
      left: 50%;
    }

    &--open span:nth-of-type(2) {
      transform: rotate(45deg);
    }

    &--open span:nth-of-type(3) {
      transform: rotate(-45deg);
    }

    &--open span:nth-of-type(4) {
      top: 1rem;
      width: 0%;
      left: 50%;
    }
  }

  // Needs to be copy + pasted and duplicated everywhere.
  @media screen and (max-width: 1470px) {
    padding: 1rem;
  }

  @media screen and (max-width: 1280px) {
    .navigation__links {
      padding: 0 1.5rem;
    }
  }

  @media screen and (max-width: 1152px) {
    .navigation__row {
      flex-direction: column;
    }

    .navigation__logo {
      align-self: flex-start;
    }

    .navigation__links {
      flex-direction: column;
      padding: 0;
      overflow: hidden;
      height: 0rem;
      max-height: 100vh;
      transition: height 0.2s ease-in-out;

      &--open {
        height: 100%;
      }

      > .navigation__link:last-of-type {
        border-bottom: none;
      }
    }

    .subnavigation__container {
      position: initial;
      opacity: 1;
      box-shadow: none;
      padding: 0 0 0 1rem;

      .navigation__link {
        white-space: pre-wrap;
        pointer-events: all;
      }

      .navigation__link:not(:first-of-type):not(:last-of-type) {
        margin: 0;
      }
    }

    .navigation__link {
      padding: 0.5rem 0;
      width: 100%;
      display: block;
    }

    .navigation__link_wrapper {
      width: 100%;
    }

    .navigation__link:nth-of-type(n + 1) {
      border-bottom: 1px solid rgb(50, 74, 93, 0.2);
    }

    .navigation__cta {
      display: none;
      visibility: hidden;
    }

    .navigation__mobile {
      display: block;
      visibility: visible;
    }
  }
`;

const SubnavigationContainer = styled.div`
  position: absolute;
  top: 1rem;
  left: -1.5rem;
  padding: 1.5rem;
  background-color: white;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease-in;

  .navigation__link {
    display: block;
  }

  .navigation__link:not(:first-of-type):not(:last-of-type) {
    margin: 1rem 0;
  }
`;

export { NavigationContainer, SubnavigationContainer };
